/* @flow */
import { create } from 'mobx-persist';
// import { AsyncStorage } from 'react-native';

import TodoList from './todo-list'
// import Area from './Area'
// import Account from './Account'
// import Download from './Download';
// import Config from './Config';

const hydrate = create({ storage: localStorage });

const stores = {
//   Counter,
    TodoList
}
 
// hydrate stores here with mobx-persist
hydrate('todolist', stores.TodoList); 


export default stores
// export default {}